import withStyles, { StyleRules } from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';

const styles = (theme): StyleRules => ({
  root: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    margin: theme.spacing(0, 0, 4),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(28),
    },
  },
});

export default withStyles(styles)(Typography);
